import { render, staticRenderFns } from "./ExpertTeamDetail.vue?vue&type=template&id=e838b2fc&scoped=true"
import script from "./ExpertTeamDetail.vue?vue&type=script&lang=js"
export * from "./ExpertTeamDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpertTeamDetail.vue?vue&type=style&index=0&id=e838b2fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e838b2fc",
  null
  
)

export default component.exports